export default __webpack_public_path__ + "static/media/designDashboard.fef6631d.webp";